import React, { useState } from 'react'
import { firestore } from '../../../../firebase';

function AddRound({id}) {

    const [round, setRound] = useState(0);
    const [date, setDate] = useState("");
    const [error, setError] = useState("");

    async function addRoundHandler(e) {
        e.preventDefault();
        try {
            const roundRef = firestore.collection("hostcup").doc(id).collection("rounds");

            const dateFormatted = new Date(date).toISOString();

            const data = {
                round, 
                date: dateFormatted
            }
            roundRef.add(data);
        } catch (error) {
            setError("Kunne ikke legge til runde");
        }
    }

    return (
        <form onSubmit={addRoundHandler}>

            <label>Dato</label>
            <input type="date" className="form-control mb-2" value={date} onChange={e => setDate(e.target.value)} placeholder="Dato" />

            <label>Runde</label>
            <input type="number" className="form-control mb-2" value={round} onChange={e => setRound(e.target.value)} placeholder="Runde" />

            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-success">Legg til runde</button>
        </form>
    )

}
export default AddRound;